import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
    Button,
    CircularProgress,
} from "@mui/material";
import { post } from "src/utils/networkUtils";

export default function RewardCoinsAllUsersDialog({
    open,
    onClose,
    onSuccess,
    onError,
}) {
    const [amount, setAmount] = useState("");
    const [transactionName, setTransactionName] = useState("");
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setAmount("");
        setTransactionName("");
        onClose();
    };

    const handleReward = async () => {
        setLoading(true);
        try {
            await post(`/admin/users/reward-welcome-coins`, {
                amount,
                transactionName,
            });
            setAmount("");
            setTransactionName("");
            onClose();
            if (onSuccess) onSuccess();
        } catch (error) {
            if (onError) onError("Failed to reward users");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="reward-dialog-title"
        >
            <DialogTitle id="reward-dialog-title">Reward All Users</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    Enter the amount and transaction name to reward all users.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="amount"
                    label="Amount"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    id="transactionName"
                    label="Transaction Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={transactionName}
                    onChange={(e) => setTransactionName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                    onClick={handleReward}
                    disabled={loading || !amount || !transactionName}
                    variant="contained"
                    startIcon={loading ? <CircularProgress size={20} /> : null}
                >
                    {loading ? "Rewarding..." : "Reward Users"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
